module.exports = __webpack_public_path__ + "8f80078afc15181a99f50dd3d244f257.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/companies/0C00006ISO.png
// module id = 1575
// module chunks = 0